<template>
  <InputGroup
    :bs="wrapperBs"
    :data-active="isOpen || null"
    placeholder="请选择日期"
    :value="value"
    v-bind="$attrs"
  >
    <template #left>
      <BeerIcon
        :icon-path="CALENDAR_14"
        :grid-size="14"
        :size="14"
        :bs="{ ml: 12, mt: 9, mb: 'auto' }"
        color="mute"
      />
    </template>
    <template
      v-if="$slots.custom"
      #custom
    >
      <slot name="custom" />
    </template>
    <template
      v-if="isOpen"
      #input-footer
    >
      <slot />
    </template>
    <template
      v-if="!$attrs['readonly'] && value"
      #right
    >
      <slot name="right">
        <BeerIcon
          :size="14"
          :bs="{
            mx: 12, transform: 'rotate(45deg)',
            fill: 'ash',
            '&:hover': { fill: 'mute' }
          }"
          icon="add-f"
          @click="handleClear"
        />
      </slot>
    </template>
  </InputGroup>
</template>

<script lang="ts">
  import {
    computed, defineComponent,
  } from 'vue'
  import BeerIcon from '@xhs/yam-beer/cmp/common/Icon/Icon.vue'
  import { CALENDAR_14 } from '@xhs/yam-beer/cmp/constants/builtinIcon'
  import InputGroup from '../InputGroup/InputGroup.vue'

  export default defineComponent({
    name: 'DateInput',
    components: {
      InputGroup,
      BeerIcon,
    },
    inheritAttrs: false,
    props: {
      bs: {
        type: Object,
        default: () => ({}),
      },
      value: {
        type: String,
      },
      isOpen: {
        type: Boolean,
        default: false,
      },
    },
    emits: ['click:clear'],
    setup(props, { attrs, emit }) {
      return {
        CALENDAR_14,
        handleClear: () => {
          emit('click:clear')
        },
        wrapperBs: computed(() => {
          let cursor: string|undefined = 'pointer'
          if (attrs.disabled) {
            cursor = 'not-allowed'
          }
          if (attrs.readonly) {
            cursor = undefined
          }
          return {
            cursor,
            input: {
              cursor: 'unset',
            },
            ...props.bs,
          }
        }),
      }
    },
  })
</script>
